import { useState, useEffect } from "react";
import { SalesExpApi } from "./Api";
import { useHybridToken } from "./Auth";

interface AISalesAppJwtResponse {
  jwt: string;
  email: string;
  employeeId: string;
}

export const useAISalesAppJwt = () => {
  const [jwtResponse, setJwtResponse] = useState<AISalesAppJwtResponse | null>(
    null
  );
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const hybridToken = useHybridToken();

  useEffect(() => {
    if (hybridToken) {
      setIsLoading(true);
      setError(null);

      SalesExpApi.getAISalesAppJwt(hybridToken)
        .then((response) => {
          setJwtResponse(response);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(
            err instanceof Error
              ? err.message
              : "Failed to get authentication token"
          );
          setIsLoading(false);
        });
    }
  }, [hybridToken]);

  return { jwtResponse, error, isLoading };
};
